// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__j2WUM","tabStyle":"Header_tabStyle__rocLq"};